import React, { useState } from 'react';
import ModalBox from './ModalBox';
import PaymentCardIcon from '../assets/images/payment-card.svg';
import PaymentSuccessIcon from '../assets/images/payment-success.svg';
import PaymentFailedIcon from '../assets/images/payment-failed.svg';

function PaymentModal({ visible, setVisible, modalTitle, children, buttonTitle, buttonAction, buttonIcon, status }) {
  
  return (
    <ModalBox title={null} visible={visible} setVisible={setVisible} className='paymentModal' bodyStyle={{ padding: 0 }} width='600px'>
      <div className='paymentModalBody'>
        <h2 className='paymentModalTitle'>{modalTitle}</h2>
        <div className='paymentModalIcon'>
          <img src={status === 'procceed' ? PaymentCardIcon : status === 'success' ? PaymentSuccessIcon : status === 'failed' ? PaymentFailedIcon : ''} alt='' />
        </div>
        {children}
      </div>
      <button className='paymentButton' onClick={buttonAction}>
        {buttonTitle}
        {buttonIcon && buttonIcon}
      </button>
    </ModalBox>
  );
}

export default PaymentModal;
